if (!customElements.get('featured-collection')) {
  customElements.define(
    'featured-collection',
    class FeaturedCollection extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.selectors = {
          sliderWrapper: '.featured-collection__items',
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        };
        this.classes = {
          grid: 'f-grid',
          swiper: 'swiper',
          swiperWrapper: 'swiper-wrapper',
        };

        this.sectionId = this.dataset.sectionId;
        this.section = this.closest(`.section-${this.sectionId}`);
        this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);

        this.enableSlider = this.dataset.enableSlider === 'true';
        this.items = parseInt(this.dataset.items);
        this.tabletItems = parseInt(this.dataset.tabletItems);
        this.mobileItems = parseInt(this.dataset.mobileItems) || 1;

        this.sliderInstance = false;

        if (!this.enableSlider) return;

        const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        mql.onchange = this.init.bind(this);
        this.init();

        window.addEventListener('load', this.updateSlider.bind(this));
      }

      isMobile() {
        return window.matchMedia(FoxTheme.config.mediaQueryMobile).matches;
      }

      init() {
        if (this.isMobile()) {
          this.destroySlider();
          this.classList.remove(this.classes.swiper);
          this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
          this.sliderWrapper.classList.add(this.classes.grid);
        } else {
          this.initSlider();
        }
      }

      initSlider() {
        if (typeof this.sliderInstance === 'object') return;

        const columnGap = window.getComputedStyle(this.sliderWrapper).getPropertyValue('--column-gap');
        const spaceBetween = parseFloat(columnGap.replace('rem', '')) * 10;
        const tabletSlides = this.tabletItems > 3 ? 3 : parseInt(this.tabletItems);

        this.sliderOptions = {
          modules: [FoxTheme.Swiper.Navigation, FoxTheme.Swiper.Pagination],
          slidesPerView: this.mobileItems,
          spaceBetween: spaceBetween,
          navigation: {
            nextEl: this.section.querySelector(this.selectors.nextEl),
            prevEl: this.section.querySelector(this.selectors.prevEl),
          },
          pagination: false,
          breakpoints: {
            768: {
              slidesPerView: tabletSlides,
            },
            1280: {
              slidesPerView: parseInt(this.items),
            },
          },
          loop: true,
          threshold: 2,
          observer: true,
          observeParents: true,
        };

        this.classList.add(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.grid);
        this.sliderWrapper.classList.add(this.classes.swiperWrapper);

        this.sliderInstance = new window.FoxTheme.Carousel(this, this.sliderOptions);
        this.sliderInstance.init();
        this.sliderInstance.slider.on('init', this.updateSlider.bind(this));

        this.calcNavButtonsPosition();
        this.fixQuickviewDuplicate();
      }

      updateSlider() {
        if (typeof this.sliderInstance !== 'object') return;

        this.sliderInstance.slider.update();
        this.calcNavButtonsPosition();
      }

      destroySlider() {
        if (typeof this.sliderInstance !== 'object') {
          this.clearSlideInlineStyles();
          return;
        }

        this.classList.remove(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
        this.sliderWrapper.classList.add(this.classes.grid);
        this.sliderInstance.slider.destroy();
        this.sliderInstance = false;
        this.clearSlideInlineStyles();
      }

      clearSlideInlineStyles() {
        this.sliderWrapper.querySelectorAll('.swiper-slide').forEach((slide) => {
          slide.removeAttribute('style');
        });
      }

      calcNavButtonsPosition() {
        if (this.dataset.calcButtonPosition !== 'true') return;

        const firstMedia = this.querySelector('.product-card__image-wrapper');
        if (firstMedia && firstMedia.clientHeight > 0) {
          this.section.style.setProperty(
            '--swiper-navigation-top-offset',
            parseInt(firstMedia.clientHeight) / 2 + 'px'
          );
        }
      }

      // calcHeadingColumnHeight() {
      //   if (this.dataset.calcHeadingColumnHeight !== 'true') return;

      //   const firstMedia = this.querySelector('.product-card__image-wrapper');
      //   if (firstMedia && firstMedia.clientHeight > 0) {
      //     this.section.style.setProperty('--heading-column-height', firstMedia.clientHeight + 'px');
      //   }
      // }

      fixQuickviewDuplicate() {
        let modalIds = [];
        Array.from(this.querySelectorAll('quick-view-modal')).forEach((modal) => {
          const modalID = modal.getAttribute('id');
          if (modalIds.includes(modalID)) {
            modal.remove();
          } else {
            modalIds.push(modalID);
          }
        });
      }
    }
  );
}
